import { SkuCardData } from '@/types/cards';
import { SkuDTO } from '@/types/api/sku';
import getSkuCardDescription from '@/utilites/get-sku-card-description';

export default function SkuCardDescription({
  sku,
  IncludeVolumeInPercent = true,
}: {
  sku: SkuDTO | null | SkuCardData;
  IncludeVolumeInPercent?: boolean;
}) {
  return (
    <>
      <span>{getSkuCardDescription(sku, IncludeVolumeInPercent)}</span>
    </>
  );
}
